<template>
    <b-card>

        <validate-form ref="form">
            <b-form>
                <b-row>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.name" label="Navn" rules="required"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.contact" label="Kontakt"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.vatNumber" label="CVR" rules="required"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.address" label="Adresse" rules="required"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.zipCode" label="Postnr." rules="required"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.city" label="By" rules="required"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.email" label="E-mail" rules="required|email"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.phone" label="Telefon" rules="required"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.mobile" label="Mobil"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.logoUrl" label="Logo URL"></FormGroup>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="4">
                        <FormGroup rules="" no-label>
                            <template #input="{state}">
                                <b-form-checkbox v-model="item.pricesIsWithVat" :state="state">
                                    Indtast priser inkl. moms
                                </b-form-checkbox>
                            </template>
                        </FormGroup>
                        <FormGroup rules="" no-label>
                            <template #input="{state}">
                                <b-form-checkbox v-model="item.showPricesWithVat" :state="state">
                                    Vis priser inkl. moms på hjemmesiden
                                </b-form-checkbox>
                            </template>
                        </FormGroup>

                        <FormGroup v-model="item.vatValue" label="Momssats"></FormGroup>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.smartwebUser" label="Smartweb brugernavn"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.smartwebPassword" label="Smartweb adgangskode"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.smartwebUrl" label="Smartweb URL"></FormGroup>
                    </b-col>
                    <b-col cols="12" md="4">
                        <FormGroup v-model="item.onPayAPI" label="OnPay API"></FormGroup>
                    </b-col>
                </b-row>
            </b-form>

            <b-button @click="saveItem" variant="primary" class="mx-5 my-5">
                {{ editing ? "Gem ændringer" : "Opret butik" }}
            </b-button>

            <b-button variant="outline-secondary" type="reset" @click="getItem" class="mx-5 my-5">
                Annuller
            </b-button>
        </validate-form>

    </b-card>
</template>

<script>
    import Toast from '@/components/_toast.vue'

    export default {
        components: {},
        data: () => ({
            item: {
                id: null
            },
            types: []
        }),
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            }
        },
        created() {
            if (this.editing) {
                this.getItem()
            } else {
                this.$store.dispatch("app/UPDATE_PAGETITLE", "Opret butik")
            }
        },
        mounted() { },
        methods: {
            getItem() {
                if (this.editing) {
                    this.$http.get("/api/stores/" + this.id).then(x => {
                        this.item = x.data

                        this.$store.dispatch("app/UPDATE_PAGETITLE", x.data.name)
                    })
                } else {
                    this.$router.push("/stores")
                }
            },
            saveItem() {
                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.$http.post("/api/stores/save", this.item).then(x => {

                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data.result,
                                    icon: 'CheckCircleIcon',
                                    variant: 'success',
                                },
                            })

                            if (x.data.data) {
                                this.$router.replace({ name: "store", params: { id: x.data.data } })
                            }

                            this.getItem()
                        })
                    }
                })
            }
        },
    }
</script>